<div class="dialog-title">{{ title }}</div>

<div class="value-container">
  <div fxLayout="row wrap" matLine>
    <div class="full-col">
      <div class="xsDesc-f">Full Name</div>
      <div class="value-f">{{result?.name || '-'}}</div>
    </div>

    <div class="half-col">
      <div class="xsDesc-f">Mobile No</div>
      <div class="value-f download-link" (click)="callTo(result?.phoneNo)">
        {{result?.phoneNo|| '-'}}
      </div>
    </div>

    <div class="half-col">
      <div class="xsDesc-f">Email Address</div>
      <div class="value-f download-link" (click)="mailTo(result?.email)">
        {{result?.email || '-'}}
      </div>
    </div>

    <div class="full-col" style="max-height: 50vh">
      <perfect-scrollbar
        style="max-height: 100vh; overflow: auto"
        [usePSClass]="true"
        [config]="psConfig"
      >
        <div
          *ngFor="let result of salesDetail; let i = index"
          class="full-col"
          fxLayout="column  wrap"
        >
          <div class="xsDesc-f">
            Project Name : {{result?.projectName || '-'}}
          </div>
          <div class="value-f">
            Unit No : {{result?.unitNo || '-' }} | {{result?.currency}}
            {{result?.price || '-' | number: "1.2-2"}} | {{result?.saleStatus ||
            '-'}}
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</div>
